import { render } from "./DataLoader.vue?vue&type=template&id=598683e2"
const script = {}

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__